import { logger } from "@src/utils/logger"

export {
  type StatusActorSnapshot,
  extractStateValue,
} from "@src/components/DefuseSDK/features/common/statusUtils"

export const WITHDRAW_STAGES = ["pending", "executing", "complete"] as const
export type WithdrawStage = (typeof WITHDRAW_STAGES)[number]

export const WITHDRAW_STAGE_LABELS: Record<WithdrawStage, string> = {
  pending: "Processing send",
  executing: "Sending",
  complete: "Complete",
}

export const WITHDRAW_STAGE_LABELS_SHORT: Record<WithdrawStage, string> = {
  pending: "Processing",
  executing: "Sending",
  complete: "Complete",
}

export function getStageFromState(stateValue: string): WithdrawStage {
  switch (stateValue) {
    case "pending":
    case "intent_settling":
      return "pending"
    case "SubmittingTxHash":
    case "checking":
    case "waiting":
    case "polling":
    case "retryDelay":
      return "executing"
    case "success":
    case "error":
      return "complete"
    default:
      logger.warn(`Unknown send state: "${stateValue}", defaulting to pending`)
      return "pending"
  }
}

export function isWithdrawStatusError(
  status: string | null | undefined,
  stateValue: string
): boolean {
  if (status != null) {
    return (
      status === "FAILED" ||
      status === "REFUNDED" ||
      status === "FAILED_EXECUTION"
    )
  }
  return stateValue === "error"
}

export function isWithdrawStatusSuccess(
  status: string | null | undefined,
  stateValue: string
): boolean {
  if (status != null) {
    return status === "SUCCESS"
  }
  return stateValue === "success"
}
